export default {
  login_register: '登入/註冊',
  booking_confirmation_title: '預訂確認',
  booking_confirmation_body: '感謝您的預訂。請在下面找到確認詳細資訊。',
  insurance_requirements_modal_disclaimer: `透過進行此預訂，我確認: 在過去 5 年內，我沒有任何犯罪記錄或駕駛違法行為。我沒有遇到過提案被拒絕、保單被取消或續保被拒絕、被要求支付增加的保費或被任何汽車保險公司施加任何特殊條件的情況。我沒有被取消駕駛資格。我沒有等待起訴或警方調查的情況。過去 5 年內，我沒有任何與竊盜、詐欺或不誠實相關的犯罪記錄。我沒有患有視力或聽力缺陷（未透過眼鏡或助聽器矯正）、心臟病、糖尿病、痙攣或任何類型的身體或精神疾病。過去 5 年裡我沒有發生過任何事故。如果您不符合這些要求，請點選{0}`,
  insurance_requirements_here: '這裡',
  insurance_requirements: '我已閱讀並瞭解 {0}',
  ir: '保險要求',
  location: '地點',
  pickup_location: '接送地點',
  dropoff_location: '還車地點',
  vehicle: '車輛',
  pickup_and_dropoff: '接送（當地時間）',
  view_voucher: '查看優惠券',
  identity_verification_body: '取車前您需要驗證您的身份',
  identity_verification_title: '驗證身份',
  search_again: '再次搜尋',
  refrigerated: '冷藏的',
  aircon_lower: '空調',
  aircon: '空調',
  refrigeration: '冷藏',
  not_available: 'Drive & Go 目前僅適用於持有以下國家/地區身分和駕駛執照文件的人員。',
  check_if_included: '檢查您的國家/地區是否包括在內。',
  included_in_booking: '包含在此預訂中',
  cdw_with_excess: 'CDW 多餘',
  theft_protection: '防盜保護過剩',
  risk_reduction: '降低風險',
  free_extras: '透過此預訂，您有權獲得兩項免費額外服務 <br />。',
  continue: '繼續',
  luggage_large_short_label: 'L',
  luggage_medium_short_label: '中號',
  luggage_small_short_label: 'S',
  luggage_large_long_label: '大的',
  luggage_medium_long_label: '中等的',
  luggage_small_long_label: '小的',
  fuel_unspecified_label: '未指定',
  transmission_manual_label: '手動的',
  transmission_automatic_label: '自動的',
  make_a_booking: '進行預訂',
  pickup_date: '提貨日期',
  dropoff_date: '還車日期',
  driver_age: '司機年齡在 30 - 65 歲之間',
  enter_driver_age: '請輸入駕駛員年齡',
  promo_code: '促銷代碼',
  search: '搜尋',
  dropoff_date_cannot_be_before_pickup_date: '還車日期不能早於取車日期',
  pickup_date_cannot_be_in_the_past: '取件日期不能是過去的日期',
  pickup_time_cannot_be_in_the_past: '取件時間不能是過去的時間',
  dropoff_time_must_be_later_than_the_pickup_time_if_on_the_same_day: '如果是同一天，送機時間必須晚於接機時間',
  vehicle_filters: '車輛濾清器',
  reset: '重置',
  transmission: '傳染',
  all: '全部',
  manual: '手動的',
  auto: '汽車',
  passengers: '乘客',
  vehicle_type: '車輛類型',
  filter: '篩選',
  vehicle_search: '車輛搜尋',
  edit: '編輯',
  no_results: '沒有結果符合您的篩選條件。',
  small_cars: '小型車',
  medium_cars: '中型車',
  large_cars: '大型車',
  estate_cars: '旅行車',
  suvs: 'SUV',
  mpvs: '多用途車',
  vans: '貨車',
  camper_vans: '露營車',
  premium: '優質的',
  unspecified: '未指定',
  large: '大的',
  medium: '中等的',
  small: '小的',
  automatic: '自動的',
  you_have_been_refunded: '您已被退款。',
  please_customer_service: '如需預訂，請聯絡我們的客戶服務。',
  contact_customer_service: '聯絡客服',
  booking_failed: '這次無法處理您的預訂。',
  summary: '概括',
  reforestation_and_protection: '支持哥斯大黎加各地的重新造林與保育雨林',
  cost_of_rental: '租金成本',
  to_pay_now: '立即付款',
  greenheart_donation: '綠心捐贈',
  total_cost: '總租金成本',
  tc_agreement: '我已閱讀並瞭解{0}。',
  tc: 'T&Cs',
  receive_offers: '我希望透過電子郵件收到特別優惠。',
  donate: '是的，我想捐款 {amount}',
  pay_now: '立即支付 {amount}',
  driver_details: '司機詳細信息',
  complete_driver_details: '請填寫司機的詳細資料。',
  are_you_the_driver: '你是司機嗎？',
  have_an_account: '您已經有帳戶了嗎？',
  login: '登入',
  or: '或者',
  first_name: '司機的名字',
  last_name: '司機姓氏',
  email: '電子郵件',
  phone_number: '手機號碼',
  unable_to_save_driver_information: '無法保存驅動程式資訊。請再試一次。',
  pay_online_now: '立即付款',
  day: '天',
  choose_location: '選擇地點',
  location_not_found: '抱歉，我們無法找到您要求的位置。',
  add: '添加',
  remove: '消除',
  free_extra: '免費額外',
  free: '自由的！',
  fast_track_notice: '文件來源限制適用於此服務。它僅適用於持有以下文件的人',
  complete_booking: '完成預訂',
  choose_card: '請選擇一張卡或新增一張新卡。',
  add_billing_details: '請新增帳單詳細資料。',
  card_number: '卡號',
  card_holder_name: '持卡人姓名',
  card_exp: '月/年',
  card_cvc: '中央VC',
  save_card: '存卡嗎？',
  amount_charged: '您的卡片將被扣款',
  payment_confirmation: '確認預訂並付款',
  payment_methods: '可用的付款方式',
  use_saved_card: 'x 使用已儲存的卡',
  use_different_card: '+ 使用不同的卡',
  book_now: '立即預訂',
  minimum_age: '超過{age}的唯一',
  excess_liability: '超額責任',
  security_deposit: '保證金',
  fuel_policy: '燃油政策',
  like_for_like: '喜歡又喜歡',
  full_to_full: '滿到滿',
  miles_per_rental: '{mileage} 每次租賃免費里程',
  km_per_rental: '{mileage} 每次租借免費公里數',
  unlimited_mileage: '不限里程',
  unlimited_mileage_km: '無限公里',
  non_amendable: '不可修改',
  non_refundable: '不退還',
  free_cancellation_until: '免費取消直至',
  cancellation_in_line_with: '取消符合',
  tcs: 'T&amp;Cs',
  free_extras_on_collection: '收藏時可免費獲得兩項額外獎勵',
  glass_and_tyres_covered: '玻璃和輪​​胎被覆蓋',
  number_of_passengers: '乘客人數',
  number_of_bags: '袋數',
  fuel_type: '燃料類型',
  co2: 'CO2',
  book_type: '書{type}',
  processing: '加工',
  actual_price: '實際價格',
  tooltip: '{currencyCode} 中的價格是基於匯率的估算，{currency} 中的價格具有約束力。',
  deposit: '訂金',
  pay_online: '立即付款',
  pay_online_without_extras: '租賃價格',
  extras_on_arrival: '抵達時的額外服務',
  insurance_on_arrival: '降低風險 - 抵達時付款',
  insurance_online: '降低風險 - 立即付款',
  extras_online: '立即支付額外費用',
  green_heart_donation: '綠心捐贈',
  why_use_drive_and_go: '為何使用 Drive & Go？',
  straight_to_car: '直接上車',
  no_queues: '無需排隊',
  self_checkout: '自助結帳',
  cant_lose_key: '鑰匙不能丟',
  online_id_check: '網上查身份證',
  phone_as_key: '電話當鑰匙',
  premiumplus_benefits_includes: 'Premium Plus+ 也包含好處',
  book_drive_go: '預訂駕車出行',
  distance_allowance: '距離津貼',
  duration: '期間',
  view_more_bookings: '看更多預訂',
  to_pay_on_arrival: '抵達時付款',
  pay_on_arrival: '抵達時付款',
  unlimited: '無限',
  return_date: '返回日期',
  postcode: '郵遞區號',
  country: '國家',
  drive_and_go: {
    drive_and_go: '開車即走',
    available_countries: 'Drive &amp; Go 目前僅適用於持有來自以下國家的身份和駕駛執照文件的人員:',
    drive_and_go_today: '立即駕車出遊預訂！',
    drive_and_go_shortened: '開車即走',
    why_use_drive_and_go: '為何使用 Drive & Go？',
    straight_to_car: '直接上車',
    no_queues: '無需排隊',
    self_checkout: '自助結帳',
    cannot_lose_the_key: '鑰匙不能丟',
    online_id_check: '網上查身份證',
    phone_as_a_key: '電話當鑰匙',
    premium_plus_benefits_also_included: 'Premium Plus+ 也包含好處',
    book_drive_and_go: '預訂駕車出行'
  },
  car_and_camp: {
    tent_and_equipment: "帳篷和裝備",
    quick_and_easy: "快速輕鬆搭建",
    travel_freedom: "旅行自由",
    affordable_campervan_alternative: "經濟實惠的露營車替代方案",
    lightweight_and_compact: "輕便小巧",
    fully_insured: "全額保險",
  },
  my_bookings: "我的預訂",
  no_bookings: "暫無預訂",
  my_profile: '我的個人資料',
  no_bookings_to_display: '沒有可顯示的預訂。',
  search_great_car_rental_deals: "為您的下次旅程搜尋優質的汽車租賃優惠。",
  odometer_at_collection: '收集中的里程表',
  fuel_at_collection: '收集時的燃油',
  start_check_in: '開始辦理登機手續',
  start_collection: '開始收集',
  recent_bookings: '最近預訂',
  damage: {
    updated_damage_report_submitted: '已提交更新的損壞報告。如果需要，我們的客戶服務團隊成員將與您聯繫。',
    add_additional_damage: '增加額外傷害',
    you_may_report_additional_damage_up_to: '您可以在車輛結帳後 24 小時內報告額外損壞',
    specify_damage: '指定傷害',
    please_choose_the_area_and_type_of_damage: '請選擇損壞的區域和類型',
    type_of_damage: '損壞類型',
    is_this_more_than_5_cm: '這超過5cm了嗎？',
    please_take_or_select_a_photo: '請拍攝或選擇一張照片',
    please_take_a_photo_ensuring_the_damage_is_clearly_visible: '請拍照以確保損壞清晰可見',
    if_you_require_you_may_add_another_photo_select_the_icon_to_add_another_photo: ' 如果需要，您可以新增另一張照片，選擇圖示以新增另一張照片',
    save_image: '儲存影像',
    save_images: '儲存影像',
    damage_saved_successfully: '傷害已成功保存',
    add_photo: '添加照片'
  },
  checkout: {
    start_collection: '開始收藏',
    collect_vehicle: '收集車輛',
    we_will_let_you_know_the_details: '我們將告知您位置和詳細信息，以便您找到租賃車輛。',
    inspect: '檢查',
    we_will_ask_for_four_photos_from_each_corner: '我們將要求提供車輛每個角落的四張照片以及尚未列出的任何新損壞。',
    fuel_and_milage: '燃油和里程',
    you_confirm_the_readings_at_the_start_of_your_hire: '您在租賃開始時確認里程表和燃油讀數。',
    sign: '符號',
    sign_the_rental_agreement: '簽署租賃協議。',
    away_you_go: '走開你就走',
    you_are_free_to_take_to_the_road: '你可以自由地上路了！',
    collect_your_vehicle: '領取您的車輛',
    get_directions: '獲取路線',
    hide_directions: '隱藏路線',
    local_time: '當地時間',
    tel: '電話',
    getting_to_the_location: '前往地點',
    get_vehicle_details: '獲取車輛詳細信息',
    view_map: '查看地圖',
    unlock_vehicle_and_continue: '解鎖車輛並繼續',
    unable_to_connect_to_vehicle: '無法連接車輛',
    we_were_unable_to_connect_to_the_vehicle_please_check: '我們無法連接到車輛 - 請檢查您是否位於正確的車輛旁邊，然後重試。',
    we_were_unable_to_find_the_vehicle_booking_please_try_again_later: '我們無法找到車輛預訂。請稍後重試。',
    odometer_and_fuel: '里程表和燃油',
    odometer: '里程表',
    please_confirm_the_odometer_and_fuel_readings: '如果可能，請確認里程表和燃油讀數。',
    the_odometer_field_is_required: '里程表欄位為必填項',
    and_must_be_greater_than_the_checkout_odometer: '& 必須大於退房里程表',
    confirm: '確認',
    please_take_a_photo_from_each_corner_of_the_vehicle: '請從車輛的各個角落拍攝照片',
    pre_existing_damage: '已有損壞',
    no_pre_existing_damage: '無預先存在的損壞。',
    new_damage: '新傷害',
    add_additional_damage: '增加額外傷害',
    no_new_damage_to_report: '沒有新的損壞報告',
    checkout_complete: '結帳完成',
    start_rental: '開始出租',
    congratulations_name_it_is_time_to_take_to_the_road: '恭喜{customer_name}，是時候上路了！',
    we_are_unable_to_complete_your_vehicle_checkout: '我們無法完成您的車輛結帳。',
    please_do_the_following: '請執行以下操作',
    remove_all_belonging_and_lock_the_vehicle: '移走所有物品並鎖好車輛。',
    lock_vehicle: '鎖車',
    once_you_have_contacted_customer_services: '聯繫客戶服務後',
    vehicle_location: '車輛位置',
    collect_your: '收集你的',
    from: '從',
    key_in_glove_box: '您的鑰匙位於手套箱中',

    keyholder: {
      not_detected: '鑰匙圈中未偵測到鑰匙',
      not_detected_please_try_again: '請將鑰匙放入鑰匙圈中，然後重試。',

      not_installed: '鑰匙扣未安裝',
      not_installed_please_contact_customer_service: 'Keyholder未安裝，請聯絡客服。',
    },
    keyring: {
      look_up_failed: '密鑰環查找失敗',
      look_up_failed_please_contact_customer_service: '鑰匙圈查找失敗，請聯絡客服。',
    },
    key: {
      invalid: '密鑰無效',
      invalid_please_contact_customer_service: '您的密鑰無效，請聯絡客服。',

      expired: '密鑰已過期',
      expired__please_contact_customer_service: '您的密鑰已過期，請聯絡客服。',
    }
  },
  checkin: {
    start_check_in: '開始辦理登機手續',
    vehicle_location: '車輛位置',
    tell_us_where_you_have_parked: '告訴我們您把車停在哪裡。',
    fuel_and_milage: '燃油和里程',
    you_confirm_the_readings_at_the_end_of_your_hire: '您在租賃結束時確認里程表和燃油讀數。',
    inspect: '檢查',
    we_will_as_for_four_photos_from_each_corner_of_the_vehicle_along_with_any_new_damage: '我們將要求提供車輛每個角落的四張照片以及租賃期間發生的任何新損壞。',
    lock: '鎖',
    check_you_have_left_no_belonging_then_lock_the_vehicle: '檢查您沒有留下任何物品，然後鎖上車輛。',
    please_tell_us_where_you_have_parked_the_vehicle: '請告訴我們您將車輛停放在哪裡',
    once_the_vehicle_is_locked_you_will_be_unable_to_unlock_it_again: '車輛一旦鎖定，您將無法再次解鎖。',
    name_please_check_you_have_left_no_belongings_then_lock_the_vehicle: '{first_name}，請檢查您沒有留下任何物品，鎖好車輛，如果需要，請將實體鑰匙歸還給鑰匙持有人。',
    lock_vehicle: '鎖車',
    complete_check_in: '完成登機手續',
    inspection: '檢查',
    complete_vehicle_check_in: '完成車輛登記',
    we_are_unable_to_complete_your_vehicle_check_in: '我們無法完成您的車輛登記。',
    please_contact_customer_services: '請聯絡客服',
    once_you_have_contacted_customer_services: '聯繫客戶服務後',
    please_amend_odometer_to_be_greater_than: '請將里程表修改為大於{odometer_value}',
  },
  rental_agreement: {
    rental_agreement: '租賃協議',
    agreement_between: '之間的協議',
    and: '和',
    sign_rental_agreement: '簽訂租約',
    i_have_read_and_understood_the_terms_and_conditions: '我已閱讀並理解條款和條件並接受車輛狀況',
  },
  additional_options: '附加選項',
  booking_details: '預訂詳情',
  price_for_x_days: '{qty_of_days} 天的價格 | {qty_of_days} 天的價格',
  cancelled: '取消',
  upcoming: '即將推出',
  active: '積極的',
  full_insurance_no_deposit: '全額保險，無押金',
  excess: '{amount} 多餘',
  deposit: '{amount}存款',
  included_daily_distance: '每天 {distance} {unit}',
  miles: '英哩',
  kilometers: '公里',
  collection_details_title: '收藏詳情',
  collection_details_not_found: '沒有為此位置定義集合詳細信息',
  free_cancellation: '免費取消',
  no_deposit: '無押金',
  benefit_from: '受益於',
  for_only_per_day: '每天僅限 {price}',
  upgrade_mee: '升級我'
}
